module.exports = new __parcel__URL__("tabs_en.e3098c8b.webp").toString();